import React, { useState, useEffect } from "react";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import CTable2 from "../../../basecomp/components/CTable2";
import CInput from "../../../basecomp/components/CInput";
import { useTranslation } from "react-i18next";
import CCarousel from "../../../basecomp/components/CCarousel";
import RcaModal from "../components/RcaModal";
import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
import CButton from "../../../basecomp/components/CButton2";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import { TextField } from "@mui/material";


const { axiosGetCallWithToken, axiosGetWithTokenHeader } = AxiosWrapper;

const Base_URL = process.env.REACT_APP_BE_URL;


const RcaPage = () => {

  const [loading, setLoading] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [openCarousel, setOpenCarousel] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [openRcaModal, setOpenRcaModal] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedType, setSelectedType] = useState("all");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [resetPage, setResetPage] = useState(0);

  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const { t } = useTranslation();


  const rowInfo = [
    {
      value: "bin_location",
      type: "T",
    },
    {
      value: "bulk_location",
      type: "T",
    },
    {
      value: "material_no",
      type: "T",
    },
    {
      value: "ohq",
      type: "T",
    },
    {
      value: "physical_qty",
      type: "T",
    },
    {
      value: "uom",
      type: "T",
    },

    // {
    //   value: (actualRow) =>
    //     actualRow.image_link.length === 0 ? <CameraAltIcon /> : <PreviewIcon />,
    //   tooltipText: (actualRow) =>
    //     actualRow.image_link.length === 0 ? "ImageUpload" : "ImageView",
    //   type: "IU",
    //   hasImage: (actualRow) =>
    //     actualRow.image_link.length === 0 ? false : true,
    //   actionV: (actualRow, images) => handleImageClick(actualRow, images),
    // },
    {
      value: "material_desc",
      type: "T",
    },
    {
      value: "last_counted_date",
      type: "T",
    },
    {
      value: "last_counted_name",
      type: "T",
    },
    {
      value: "summary",
      type: "T",
    },
    {
      value: (actualRow) => actualRow.rca_performed ? "View RCA" : "Perform RCA",
      color: (actualRow) => actualRow.rca_performed ? "success" : "error",
      fullWidth: true,
      tooltipText: "View",
      status: `material_status`,
      type: "B",
      isDisable: (actualRow) => false, // Always enabled for now
      actionV: (actualRow) =>
        handleProcessClick(actualRow, actualRow.rca_performed),
    },

  ];

  const handleProcessClick = (actualRow, viewOnly) => {
    setSelectedMaterial(actualRow);
    setOpenRcaModal(true);
    setViewOnly(viewOnly)
  };

  const infoHeadData = [
    t("bin_loc"),
    t("bulk_loc"),
    t("material_number"),
    t('ohq'),
    t('Physical QTY'),
    t('uom'),
    t("material_desc"),
    t("Last counted at"),
    t("Last counted by"),
    t("Last counted status"),
    t("Action")
  ];



  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(0);
      setResetPage((prev) => prev + 1);
      setDebouncedSearch(search.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);


  useEffect(() => {
    const fetchMaterials = async () => {
      if (fromDate && !toDate) {
        console.warn("To date is required when from date is selected.");
        return;
      }
      if (!fromDate && toDate) {
        console.warn("From date is required when to date is selected.");
        return;
      }

      // Don't fetch if the requested page is beyond available records.
      if (totalCount > 0 && page * limit >= totalCount) {
        return;
      }
      const startIndex = page * limit;
      const endIndex = startIndex + limit;

      // Skip API call if this page's records are already loaded.
      // if (materials.length >= endIndex || materials.length >= totalCount) {
      //   return;
      // }

      setLoading(true);

      try {
        const response = await axiosGetCallWithToken(
          `${Base_URL}/label_print/rca-materials?page=${page + 1}&limit=${limit}&fromDate=${fromDate ? format(fromDate, "yyyy-MM-dd") : ""}&toDate=${toDate ? format(toDate, "yyyy-MM-dd") : ""}&type=${selectedType}&search=${encodeURIComponent(debouncedSearch)}`);

        const data = response.data.data || [];
        console.log("Fetched materials:", data);

        const formattedMaterials = data.map((material) => ({
          ...material,
          last_counted_date: material.last_counted_date
            ? new Date(
              Number(material.last_counted_date) * 1000
            ).toLocaleString("en-US")
            : material.last_counted_date,
        }));

        setMaterials((prevMaterials) =>
          page === 0 ? formattedMaterials : [...prevMaterials, ...formattedMaterials]
        );
        setTotalCount(response.data.total_count ?? 0);
      } catch (error) {
        console.error("Error fetching materials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, [page, limit, fromDate, toDate, selectedType, debouncedSearch]);

  const handlePageChange = (newPage) => {
    console.log("Page change requested:", newPage);
    setPage(newPage);
  };

  const handleLimitChange = (value) => {
    setLimit(parseInt(value, 10));
    setPage(0);
  };

  const handleRcaSubmitSuccess = (new_ohq) => {
    setMaterials((prevMaterials) =>
      prevMaterials.map((item) => {
        if (
          item.material_counting_id !==
          selectedMaterial.material_counting_id
        ) {
          return item;
        }

        const original = Number(item.ohqty);
        const updated = Number(new_ohq);

        let summary = "";

        if (original === updated) {
          summary = "No Difference";
        } else if (updated === 0) {
          summary = "Not found";
        } else if (original > updated) {
          summary = `${original - updated} less`;
        } else {
          summary = `${updated - original} excess`;
        }

        return {
          ...item,
          rca_performed: true,
          summary,
          physical_qty: updated,
          updated_qty: updated,
        };
      })
    );
  };


  const downloadRcaReport = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        type: selectedType || "all",
        fromDate: fromDate ? format(fromDate, "yyyy-MM-dd") : "",
        toDate: toDate ? format(toDate, "yyyy-MM-dd") : "",
        search: search || "",
      });
      const response = await axiosGetWithTokenHeader(
        `${Base_URL}/label_print/rca-export?${params.toString()}`
      );

      if (!response?.data) {
        console.error("No file data received");
        return;
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "RCA_Report.xlsx";

      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      setLoading(false)
      console.error("Error downloading RCA report:", error);
    }
  };



  return (
    <div
      style={{
        marginTop: "3em",
        padding: "1rem",
      }}
    >
      <CBackDrop cOpen={loading} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          mb: 2,
          mt: 3
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flex: 1,
            flexWrap: "wrap",
            minWidth: 0,
          }}
        >
          <TextField
            size="small"
            type="text"
            label="Search"
            placeholder="Material, bin location or counted by"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              flex: "1 1 240px",
              minWidth: 220,
              maxWidth: 350,
            }}
          />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="From Date"
              value={fromDate}
              onChange={(value) => {
                setFromDate(value);
                setPage(0);
                setResetPage((prev) => prev + 1);
              }}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 160 },
                },
              }}
            />

            <DatePicker
              label="To Date"
              value={toDate}
              minDate={fromDate || undefined}
              onChange={(value) => {
                setToDate(value);
                setPage(0);
                setResetPage((prev) => prev + 1);
              }}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 160 },
                },
              }}
            />
          </LocalizationProvider>

          <FormControl size="small" sx={{ width: 130 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={selectedType}
              label="Type"
              onChange={(e) => {
                setSelectedType(e.target.value);
                setPage(0);
                setResetPage((prev) => prev + 1);
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="less">Less</MenuItem>
              <MenuItem value="excess">Excess</MenuItem>
            </Select>
          </FormControl>

          <button
            onClick={() => {
              setFromDate(null);
              setToDate(null);
              setSelectedType("all");
              setSearch("");
              setDebouncedSearch("");
              setPage(0);
              setResetPage((prev) => prev + 1);
            }}
            disabled={!fromDate && !toDate && selectedType === "all" && !search}
            style={{
              backgroundColor: "white",
              color: "black",
              border: "1px solid #ccc",
              padding: "7px 14px",
              borderRadius: "4px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              opacity: !fromDate && !toDate && selectedType === "all" && !search ? 0.5 : 1,
            }}
          >
            Clear Filters
          </button>
        </Box>

        <CButton
          cText="Download RCA Report"
          cColor="primary"
          cOnClick={downloadRcaReport}
        />
      </Box>


      <CTable2
        cHeaderData={infoHeadData}
        cRowData={rowInfo}
        cActualData={materials}
        cIsPagination={true}
        cSmallSize={true}
        resetPage={resetPage}
        realPagination={true}
        totalCount={totalCount}
        handlePageChange={handlePageChange}
        handleLimitChange={handleLimitChange}
      />

      {openCarousel && (
        <CCarousel
          cOpen={openCarousel}
          images={carouselImages}
          cClose={() => setOpenCarousel(false)}
        />
      )}

      <RcaModal
        open={openRcaModal}
        onClose={() => setOpenRcaModal(false)}
        material={selectedMaterial}
        onSubmitSuccess={handleRcaSubmitSuccess}
        viewOnly={viewOnly}
      />



    </div>
  )
}

export default RcaPage